<div class="col-md-4">
  <div class="card">
    <img src="{{options?.icon}}" style="
   
    margin-top: 50px;
   "
         [style.width]="width"/>
    <h2>{{options?.title}}</h2>
    <h4>
      {{options?.slogen}}
    </h4>
    <h1 style="color: #dc291e;" [style.marginTop.px]="marginTop" >{{options?.count}}</h1>
    <h4>{{options?.type}}</h4>
  </div>
</div>
